import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const OutLook = () => {
  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row" style={{ marginTop: 50 }}>
              <div className="col-md-12 grid-margin transparent">
                <div className="row">
                  <div className="col-md-12 stretch-card transparent">
                    <div className="card card-white">
                      <div className="card-body">
                        <Outlet />
                      </div>

                      <footer className="footer">
                        <div className="d-sm-flex justify-content-center justify-content-sm-between">
                          <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
                            Copyright © {new Date().getFullYear()}.{` `}
                            <a href="https://www.samtec.ng/" target="_blank" rel="noreferrer">
                              Samtec & Associate Nigeria Limited
                            </a>{" "}
                          </span>
                          <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
                            <i className="ti-heart text-danger ml-1"></i>
                          </span>
                        </div>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutLook;
